import React, { useState, useCallback } from "react";
import "../styles/MatchDaysList.css";
import { putItem } from "../../../utils/api";
import Loader from "sulu-admin-bundle/components/Loader";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useTranslation } from "react-i18next";

export default function IsOfficialSwitch({
    matchDay,
    disabled = false,
    isOfficial,
    setIsOfficial,
}) {
    const [switchLoading, setSwitchLoading] = useState(false);
    const { t } = useTranslation();

    const handleSwitchChange = useCallback(
        async (event) => {
            const value = event?.target?.checked;
            const addSwitchUrl = `/admin/api/dhbmatchdays/${matchDay?.matchDayKey}`;
            setSwitchLoading(true);
            try {
                const response = await putItem(addSwitchUrl, {
                    isOfficial: value,
                });
                setIsOfficial(response?.isOfficial);
                setSwitchLoading(false);
            } catch (error) {
                setSwitchLoading(false);
                console.log("Switch Change Error");
            }
        },
        [matchDay]
    );

    return (
        <div style={{ textAlign: "right" }}>
            <FormControlLabel
                control={
                    !switchLoading ? (
                        <div className="switch-wrap">
                            <Switch
                                checked={isOfficial}
                                onChange={handleSwitchChange}
                                disabled={disabled}
                                name="isOfficial"
                            />
                        </div>
                    ) : (
                        <div className="switch-wrap">
                            <Loader size={40} />
                        </div>
                    )
                }
                label={t("gamedays.matchday_block.switch_label")}
                labelPlacement="start"
            />
        </div>
    );
}
